import * as moment from 'moment';
import { DateTimeConverter } from '../../../core/services/mapper/converters';

export class TourneeFilter {
    static jsonMap = {
        id: { key: 'id', optional: true },
        dateDebut: { key: 'dateDebut', converter: new DateTimeConverter(), optional: true },
        numero: { key: 'numero', optional: true, default: '' }
    };

    id: number;
    dateDebut: moment.Moment;
    numero: string;
}
